import React from 'react';
import { SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { getLink } from '../../utils';

const ActionRegister: React.FC = () => {
  const { t } = useTranslation('action_register');
  function redirectTo() {
    window.location.href = getLink('cadastro');
  }

  return (
    <div className="action-register">
      <div className="action-content">
        <h6>{t('title')}</h6>
        <p>{t('description')}</p>
        <SmlsButton
          data-testid="action-register-button"
          className="action-btn-register"
          color="pills"
          text="Criar conta"
          type="button"
          onClick={() => redirectTo()}
        />
      </div>
    </div>
  );
};

export default ActionRegister;
